import { fetchAuthSession } from 'aws-amplify/auth';

export const getCurrentSession = async () => {
  const { accessToken, idToken } = (await fetchAuthSession()).tokens ?? {};
  return {
    accessToken: accessToken?.toString() || '',
    idToken: idToken?.toString() || '',
  }
}
